import { render, staticRenderFns } from "./senderList.vue?vue&type=template&id=e20eacb8&scoped=true"
import script from "./senderList.vue?vue&type=script&lang=js"
export * from "./senderList.vue?vue&type=script&lang=js"
import style0 from "./senderList.vue?vue&type=style&index=0&id=e20eacb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20eacb8",
  null
  
)

export default component.exports